import { apiClient, getToken, getOrgId } from '@devd-client/api';

export const getAllSubsPlans = (params: any): Promise<any> =>
  apiClient(
    `/v2/subscription/plans?duration=${
      params.duration === 'Monthly' ? 'month' : 'year'
    }`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const getAllNotifications = (): Promise<any> =>
  apiClient(`/v1/alarms/${getOrgId()}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const markAsRead = (params: any): Promise<any> =>
  apiClient(`/v1/alarms/${params.id}/mark-as-read`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({}),
  });

export const shownTrialEndModal = (params: any): Promise<any> =>
  apiClient(`/v1/user/${params.id}/preference/displayUpgrade`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      displayed: params.displayed,
    }),
  });

export const getOrdinalSteps = (): Promise<any> =>
  apiClient(`/v2/account/org/${getOrgId()}/setup`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });
